import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { TicketService } from 'src/app/services/ticket.service';
import { TicketLogsItem } from 'src/app/interface/ticket';
@Component({
  selector: 'app-mobile-log',
  templateUrl: './mobile-log.component.html',
  styleUrls: ['./mobile-log.component.css']
})
export class MobileLogComponent implements OnInit {
  ticketId:number = 0;
  ticketNo:string = "";
  guid:string = "";
  logListOfData:TicketLogsItem[] = []; // 日志数据
  constructor(private route: ActivatedRoute,private ticketService:TicketService,private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.ticketId = parseInt(params['id']) ;
      this.ticketNo = params['ticketNo'];
      this.guid = params['guid'];
      let param = {
        "page": 0,
        "pageSize": 10,
        "keyword": "",
        "id": this.ticketId,
        "isDescrSubmittedDate": true,
        "skipUntil": "",
        "skipIds": [],
      }
      this.ticketService.getTicketLogsList(param).subscribe((res) => {
        this.logListOfData = res.data;
      })
    });
  }

  back() {
    this.router.navigate(['/mobile-ticket'],{queryParams:{id:this.ticketId,guid:this.guid}});
  }

}
